import {NavigationPageEnum, NavigationPageEnumHumanReadable} from '../../navigations.enums';
import {IUserAccessFeature, IUserAccessSubFeatures} from '../user-access-features';
import {SettingsReferenceEnum} from '../../../../settings-new/models';

//#region INTERFACE IFeatureLabelMaker
export interface IFeatureLabelMaker extends IUserAccessSubFeatures, IUserAccessFeature, Object {
}

//#endregion

//#region CONST _FEATURE_LABEL_MAKER_DEFAULT
export const _FEATURE_LABEL_MAKER_DEFAULT: Readonly<IFeatureLabelMaker & Object> = {
  displayText: NavigationPageEnumHumanReadable.LabelMaker,
  feature: NavigationPageEnum.LabelMaker,
  ref: SettingsReferenceEnum.featureLabelMaker,
  standalone: true,
};
//#endregion